export var AlertVariant;
(function (AlertVariant) {
    AlertVariant["default"] = "default";
    AlertVariant["brand"] = "brand";
    AlertVariant["gray"] = "gray";
    AlertVariant["warning"] = "warning";
    AlertVariant["error"] = "error";
    AlertVariant["success"] = "success";
    AlertVariant["info"] = "info";
})(AlertVariant || (AlertVariant = {}));
